<script>
  import { _ } from "svelte-i18n";
</script>

<footer class="unselectable">
  <div class="copyright">
    Copyright 2022 &copy Tamas Nemes. {$_("footer")} <a
      href="https://svelte.dev/"
      target="_blank"
      rel="noopener noreferrer">Svelte</a
    >
    |
    <a href="https://d3js.org/" target="_blank" rel="noopener noreferrer"
      >D3.js</a
    >
    |
    <a href="https://fontawesome.com/" target="_blank" rel="noopener noreferrer"
      >FontAwesome</a
    >
    |
    <a href="https://www.mathjax.org/" target="_blank" rel="noopener noreferrer"
      >MathJax</a
    >
  </div>
  <div class="icons">
    <a
      href="https://github.com/Totemi1324"
      target="_blank"
      rel="noopener noreferrer"><span class="fa fa-github" /></a
    >
    <a
      href="https://www.youtube.com/channel/UCy364Kb1nLAqbNyRjQZNVqw"
      target="_blank"
      rel="noopener noreferrer"><span class="fa fa-youtube" /></a
    >
    <a
      href="https://twitter.com/LightcraftStud1"
      target="_blank"
      rel="noopener noreferrer"><span class="fa fa-twitter" /></a
    >
    <a
      href="https://www.linkedin.com/in/tamas-nemes-459950175/"
      target="_blank"
      rel="noopener noreferrer"><span class="fa fa-linkedin" /></a
    >
  </div>
</footer>

<style>
  footer {
    padding: 40px;
    text-align: center;
  }
  .copyright {
    color: #aaa;
    font-size: 14px;
    display: inline-block;
    padding: 30px 30px 10px 30px;
    border-top: 1px solid #ddd;
  }
  .copyright a {
    color: #aaa;
    text-decoration: underline;
    transition: opacity 0.25s ease-out;
  }
  .copyright a:hover {
    opacity: 0.7;
  }
  .fa {
    color: #aaa;
    font-size: 1.2rem;
    transition:0.25s ease-out;
  }
  .fa:hover, .fa:focus {
    transform: scale(1.1);
    opacity: 0.7;
  }
</style>
